import { useMemo, useEffect } from "react";
import { getTripKey } from "../../utils/tripAnalysis";
import { useEscaletedLinesTodayStore } from '../../stores/hashs/useEscaletedLinesTodayStore';
import { useTripAlertsAnalysisStore } from '../../stores/analysis/useTripAlertsAnalysisStore';
import { useAlertN3Store } from "../../stores/hashs/useAlertN3Store";


export function useAlertsN3() {

    const trips = useEscaletedLinesTodayStore(
        state => state.data
    );

    const totalDay = useEscaletedLinesTodayStore(
        state => state.total
    );

    const alertsMap = useTripAlertsAnalysisStore(
        state => state.alertsMap
    );

    const setAlertN3 =
        useAlertN3Store(
            state => state.setAlertN3
        );

    const value = useMemo(() => {

        const data = [];

        for (const trip of trips) {

            const alerts = alertsMap.get(
                getTripKey(trip.DATA_REFERENCIA, trip.CODIGO_INTEGRACAO)
            );

            if (!alerts?.n3) {
                continue;
            }

            data.push(trip);

        }

        const total = data.length;

        return {
            data,
            total,
            totalDay,
            percentTotal:
                totalDay
                    ? Math.round(total / totalDay * 100)
                    : 0
        };

    }, [
        trips,
        alertsMap,
        totalDay
    ]);


    useEffect(() => {

        setAlertN3(value);

    }, [
        value,
        setAlertN3
    ]);

}